import Store from '@/store';
import EsMarcaClient from '@/api/SistemaDKP/sls-marca.client';
import Notifier from '@/libs/Notifier';
import { resolveImagemUrl } from '@/utils/imagemUrl';

export default class SLSMarcaService {
  constructor() {
    this.client = new EsMarcaClient();
    this.store = Store;
    this.notify = new Notifier();
  }

  async findAll() {
    try {
      const { data, ...pagination } = await this.client.getEsMarca(this.store.getters['slsMarca/getFilters']);
      this.store.commit('slsMarca/setEsMarcas', data);
      this.store.commit('slsMarca/setFilters', {
        ...pagination,
        hasMore: true,
      });
    } catch (error) {
      console.log(error);
    }
  }

  async obterMarcarPorCodMarca(codMarcaId) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await this.client.obterMarcarPorCodMarca(codMarcaId);
        const normalized = data && typeof data === 'object'
          ? {
            ...data,
            caminho: resolveImagemUrl(data.caminho),
            caminho_catalogo: resolveImagemUrl(data.caminho_catalogo),
            caminho_img_cabec_marcas: resolveImagemUrl(data.caminho_img_cabec_marcas),
            caminho_img_footer_principal: resolveImagemUrl(data.caminho_img_footer_principal),
            caminho_img_footer_secundaria: resolveImagemUrl(data.caminho_img_footer_secundaria),
          }
          : data;
        this.store.commit('slsMarca/setCurrentCatalogoMarca', normalized);
        resolve(normalized);
      } catch (error) {
        this.notify.error('Erro ao buscar marca');
        reject(error);
      }
    });
  }

  async listarCategoriasPorMarca(codMarcaId) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await this.client.listarCategoriasPorMarca(codMarcaId);
        this.store.commit('slsMarca/setOptionsCategorias', data);
        resolve(data);
      } catch (error) {
        this.notify.error('Erro ao buscar categorias');
        reject(error);
      }
    });
  }

  async listarImagensPorMarca(codMarcaId, queries = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.client.listarImagensPorMarca(codMarcaId, queries);
        const imagens = Array.isArray(response) ? response : response?.data || [];
        const normalized = Array.isArray(imagens)
          ? imagens.map((item) => {
            const itemId = item.item_id ?? item.itemId ?? item.CodItem;
            const descricao = item.item_descricao ?? item.itemDescricao
              ?? item.Descricao ?? item.item_name ?? '';
            return {
              ...item,
              // Keep both API spellings available to older catalog consumers,
              // but make the SKU the only identity used by the Home row.
              item_id: itemId,
              itemId,
              item_descricao: descricao,
              itemDescricao: descricao,
              Descricao: item.Descricao ?? descricao,
              caminho: resolveImagemUrl(item.caminho),
              imagens: Array.isArray(item.imagens)
                ? item.imagens.map((imagem) => ({
                  ...imagem,
                  caminho: resolveImagemUrl(imagem.caminho),
                }))
                : item.imagens,
            };
          }).filter((item) => item.item_id !== null && item.item_id !== undefined
            && String(item.item_id).trim() !== '')
          : imagens;

        this.store.commit('slsMarca/setImagensPorMarca', normalized);
        resolve(Array.isArray(response) ? normalized : { ...response, data: normalized });
      } catch (error) {
        this.notify.error('Erro ao buscar imagens');
        reject(error);
      }
    });
  }

  async listarImagensPorMarcaRaw(codMarcaId, queries = {}) {
    try {
      return await this.client.listarImagensPorMarca(codMarcaId, queries);
    } catch (error) {
      this.notify.error('Erro ao buscar imagens');
      throw error;
    }
  }

  async loadingCatalogoMarca(codMarcaId) {
    await this.obterMarcarPorCodMarca(codMarcaId);
    await this.listarCategoriasPorMarca(codMarcaId);
    await this.listarImagensPorMarca(codMarcaId);
  }

  async listarReferenciasPorCategoriaCodMarca(codMarca, codCategoria) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await this.client.listarReferenciasPorCategoriaCodMarca(codMarca, codCategoria);
        this.store.commit('slsMarca/setOptionsReferencias', data);
        resolve(data);
      } catch (error) {
        this.notify.error('Erro ao buscar referências');
        reject(error);
      }
    });
  }
}
